import Types from '../../reducers/app/types';

const show = ({ severity = 'warning', message }) => ({
  type: Types.SHOW_ALERT_BANNER,
  payload: { severity, message },
});

const hide = () => ({
  type: Types.HIDE_ALERT_BANNER,
});

export default { show, hide };
